/**
 * Shared landing-page CTA destinations. Self-serve "Sign up" funnels to
 * signup; "Log in" to login; every "Request a demo" / "Contact sales" CTA
 * funnels to the demo-request form. Centralized here so no CTA can drift
 * to the wrong destination independently.
 */
export const LOGIN_HREF = '/login'
export const SIGNUP_HREF = '/signup'
export const DEMO_HREF = '/demo'
